import React from "react";

import styles from "../../../styles/service/cart-items.module.scss";
import { Currency } from "../../utils/Currency";
import { OrderStorage } from "storage/OrderStorage";
import { If } from "shared/components/control-statements";
import { CatalogHelpers } from "shared/tools/CatalogHelpers";

import css from "classnames";

const CartItems = ({ isConfirmOrder }) => {
  const order = OrderStorage.getOrder();

  const renderExtra = (extraIngredient) => (
    <span className={styles.productExtra}>{extraIngredient.name}</span>
  );

  const renderQuestion = (question) => {
    const childrenQuestions = (question.items || [])
      .map((option) => option.items || [])
      .flat(1);

    const questions = [question, ...childrenQuestions];

    const filteredQuestions = questions.filter(
      (q) => q.items?.filter((o) => o.selected).length > 0,
    );

    return (
      <>
        {filteredQuestions.map(
          (q, index) =>
            q.items.length > 0 && (
              <div key={index} className="d-flex flex-column">
                <span className={styles.stepName}>{q.name}</span>
                {q.items
                  .filter((o) => o.selected)
                  .map((option, idx) => (
                    <span key={idx} className={styles.productOption}>
                      {option.quantity}x {option.name}
                    </span>
                  ))}
              </div>
            ),
        )}
      </>
    );
  };

  const renderItem = (item, index) => {
    const selectedSize = item.sizes[0];

    const decreaseQuantity = () => {
      if (item.quantity === 1) return;

      const updated = { ...item, quantity: item.quantity - 1 };
      OrderStorage.updateCartItem(index, updated);
    };

    const increaseQuantity = () => {
      const updated = { ...item, quantity: item.quantity + 1 };
      OrderStorage.updateCartItem(index, updated);
    };

    const removeCartItem = () => {
      OrderStorage.removerCartItem(index);
    };

    return (
      <div
        key={index}
        className={css(styles.product, {
          [styles.isConfirmOrder]: isConfirmOrder,
        })}
      >
        <div className="d-flex align-center">
          <div className={styles.quantity}>{item.quantity || 1}x</div>
          <span className={styles.productName}>{item.name}</span>
        </div>

        <div className="d-flex flex-column">
          <span className={styles.productSize}>
            Tamanho: <span>{selectedSize?.name}</span>
          </span>

          {item.type === "step" &&
            item.items.map((q, i) => renderQuestion(q, i))}

          <If cond={item.extra_ingredients?.length > 0}>
            <p className={styles.productQuestion}>Ingredientes extras</p>
            {item.extra_ingredients?.map((extra, i) => (
              <div className="d-flex flex-column">{renderExtra(extra, i)}</div>
            ))}
          </If>
        </div>

        <div className="d-flex align-center justify-between mt-20">
          <p className={styles.productPrice}>
            {Currency.formatCurrency(
              CatalogHelpers.calculateSelectedItemPrice(item) || 0,
            )}
          </p>

          <div className="d-flex align-center">
            <div className={styles.quantityContainer}>
              <div
                className={css(styles.minus, {
                  [styles.disabled]: item.quantity === 1,
                })}
                onClick={decreaseQuantity}
              >
                <i className="fal fa-minus" />
              </div>

              <p className={styles.qty}>{item.quantity}</p>

              <div className={styles.plus} onClick={increaseQuantity}>
                <i className="fal fa-plus" />
              </div>
            </div>
            <div className={styles.divider} />
            <div className="d-flex align-center gap-10">
              <div className={styles.remove} onClick={removeCartItem}>
                <i className="fal fa-trash" />
              </div>
              {/* <div className={styles.remove} onClick={removeCartItem}>
                <i className="fal fa-sticky-note" />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const {
    cart: { catalog },
  } = order;

  return catalog.items.map((item, index) => renderItem(item, index));
};

export default CartItems;
